import { Rocket, Brain, Users, Zap } from "lucide-react";

export const VibeCodingKeyFindings = () => {
  const findings = [
    {
      icon: Rocket,
      stat: "10x",
      title: "Faster Time to Production",
      description: "Teams using vibe coding report shipping features in hours that previously took days. The biggest gains come from eliminating boilerplate and reducing context switching.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Brain,
      stat: "92%",
      title: "Developers Using AI Tools",
      description: "GitHub's 2024 survey shows the vast majority of developers now use AI coding assistants. Those who don't are falling behind in productivity.",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Users,
      stat: "Non-devs",
      title: "Building Real Apps",
      description: "Vibe coding has enabled founders, designers, and product managers to build functional prototypes and even production apps without traditional coding skills.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Zap,
      stat: "70%",
      title: "Reduction in Boilerplate",
      description: "AI handles repetitive code patterns, config files, and standard implementations automatically — freeing developers to focus on unique business logic.",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Why Vibe Coding is Taking Over
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        The shift from "writing code" to "describing intent" represents the biggest change in software 
        development since the move from assembly to high-level languages.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
